import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  teamListArr: any = [
    {
      id: 1,
      name: 'Mr. Narendra Vansjalia',
      image: 'assets/img/team/Narendra-Vansjalia.png',
      occupation: 'Managing Director',
      details: 'Mr. Narendra Vansjalia is a Textile Technologist and having 30 years experience. He has worked with leading textile manufacturing company M/s. Arvind Mills Ltd. for 22 years. Out of 22 years, he worked 12 years in Indigo Sheet and Rope dye - size plants. He worked one year at M/s. Modern Denims Ltd., As Vice President. Last 8 years his firm Venus Corporation was tied up with M/s. Jupiter Engineering Co. for developing and manufacturing of Indigo Sheet Dye and Size Machines. During this tenure total 16 nos. Indigo Sheet Plants were manufactured and commissioned successfully.',
      facebookLink: '#',
      linkedinLink: '#',
      instaLink: '#',
    },
    {
      id: 2,
      name: 'Mr. Bhogilal Patel',
      image: 'assets/img/team/Bhogilal-Patel.png',
      occupation: 'Director',
      details: 'Mr. Bhogilal Patel has total experience of 33 years for Production, Administration and commercial activity for engineering unit. He has been associated with company M/s. Ultra Wire Pvt. Ltd. He is looking after finance of our group companies.',
      facebookLink: '#',
      linkedinLink: '#',
      instaLink: '#',
    },
    {
      id: 3,
      name: 'Mr. Dilip Patidar',
      image: 'assets/img/team/Dilip-Patidar.png',
      occupation: 'Director',
      details: 'Mr. Dilip Patidar is a technocrat with total experience of 18 years. He has been associated with leading pharma machine manufacturer company M/s. Cadmach Machinery Pvt. Ltd in the capacity of Assistant Branch Manager for 6 years. Also associated with M/s. Chamunda Pharma Machinery Co. Pvt Ltd., in their Production and Sales dept. for 3 years and having experience 8 years in leading wood cutting machine manufacturing company Sharpex Engineering.',
      facebookLink: 'https://www.facebook.com/prismpharmamachinery/',
      linkedinLink: 'https://www.linkedin.com/in/prismpharma/?originalSubdomain=in',
      instaLink: '#',
    }
  ]

  constructor() {}

  ngOnInit() {
  }

  

}
